//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getArtworkDetail, getPixiId } from '@/api/artwork'
import { getSectionInfo } from '@/utils/helper'
import { chunk } from 'lodash'
import { sortBy } from 'lodash'
import PageFooter from '@/components/PageFooter'
import PageLogo from '@/components/PageLogo'
import ViewerMirador from "@/components/ViewerMirador/index";
import ArtworkTitle from "@/views/partial/ArtworkTitle";

export default {
  name: 'Artwork',
  components: { PageFooter, PageLogo, ViewerMirador, ArtworkTitle },
  data () {
    // console.log(this.$route.params.id)
    // console.log(this.$route.query.isFromPixi)
    return {
      id: this.$route.params.id,
      // id: process.env.NODE_ENV === 'production' ? 1 : 13,
      artwork: {},
      miradorURL: undefined,
      sectionListWithoutId: undefined,
      imageUrlForId: undefined,
      artworksForIdGrouped: undefined,
      artworksForId: undefined,
      slideModel: 0,
      widthMax: document.documentElement.clientWidth,
      lastY: 0
    }
  },
  computed: {
    langNotEn() {
      return localStorage.getItem('keio.lang') !== 'en';
    }
  },
  async created() {
    await this.fetchData();
    if (this.artwork.stringifyLinks) {
      this.miradorURL = {
        windows: [
            {
              manifestId: JSON.parse(this.artwork.stringifyLinks)[0].url
              // manifestId: 'https://iiif.harvardartmuseums.org/manifests/object/299843'
            }
        ]
      }
    }
    // console.log('created end')
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll)
  },
  updated() {
    this.widthMax = document.documentElement.clientWidth
    const target1 = this.$refs['scrollArea']
    const target2 = this.$refs['scrollMore']
    
    if (this.widthMax <= -1) {
      if (this.artworksForId && this.artworksForId.length > 0) {
        target1.setScrollPosition((this.widthMax * (320 + 8) / 375) * Math.floor((this.artworksForId.length - 1) / 2), 0)
      }
      if (this.artwork.contents && this.artwork.contents.length > 0) {
        target2.setScrollPosition((this.widthMax * (320 + 8) / 375) * Math.floor((this.artwork.contents.length - 1) / 2), 0)
      }
    }
    
    // hack code for editor content
    const rootContent = document.getElementById('content');
    if (rootContent) {
      const result = rootContent.getElementsByTagName('p');
      for(let i = 0; i !=result.length; i++) {
        if (result[i].querySelectorAll('img').length !== 0) {
          result[i].style['max-width'] = '100%';
        }
      }
    }
  },
  
  destroyed () {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
      onScroll() {
        if (Math.abs(window.scrollY - this.$refs['mi'].offsetTop) < 100 && Math.abs(this.lastY - window.scrollY) > 300) {
          window.scrollTo(0, this.lastY);
        } else {
          this.lastY = window.scrollY
        }
      },
      async fetchData() {
          if (this.$route.query.isFromPixi) {
            const realId = await getPixiId(this.id)
            // console.log(`realId: ${realId}`)
            if (this.id === undefined) {
              this.$router.push({ name: 'Error', params: { status: 404 } })
            } else {
              this.id = realId
            }
          }

          this.artwork = await getArtworkDetail(this.id);

          const { sectionListWithoutId, imageUrlForId, artworksForId } = await getSectionInfo(this.artwork.sections.length && this.artwork.sections[0] ? this.artwork.sections[0].id : 0)
          // console.log(1111)
          // console.log(sectionListWithoutId)
          // console.log(this.artwork)
          // console.log(artworksForId)
          this.sectionListWithoutId = sectionListWithoutId
          this.imageUrlForId = imageUrlForId
          this.artworksForId = sortBy(artworksForId, [function(o) { return o.title; }])
          this.artworksForIdGrouped = chunk(artworksForId, 4)
      },
      onClickLeft(refName) {
        // console.log('onClickLeft')
        const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
        const target = this.$refs[refName]
        const rate = this.widthMax <= 768 ? 100 * (320 + 8) / 375 : 25
        target.setScrollPosition(target.getScrollPosition() - rate * vw / 100, 100)
      },
      onClickRight(refName) {
        // console.log('onClickRight')
        const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
        const target = this.$refs[refName]
        const rate = this.widthMax <= 768 ? 100 * (320 + 8) / 375 : 25
        var scrollTo = target.getScrollPosition() + rate * vw / 100
        if (scrollTo + this.widthMax * (320 + 8) / 375 <= target.scrollSize) {
          target.setScrollPosition(scrollTo, 100)
        }
      },
      handleResize() {
        this.widthMax = document.documentElement.clientWidth
      },

      getScrollWidth() {
        return this.widthMax + 'px'
      },
      getScrollHeight() {
        if (this.widthMax <= 768) {
          return 'calc(572/375*100vw)'
        }
        return 'calc(805/1920*100vw)'
      },
      getScrollPT() {
        if (this.widthMax <= 768) {
          return 'calc(48/375*100vw)'
        }
        return 'calc(96/1920*100vw)'
      },
      getRowWidth() {
        if (this.widthMax <= 768) {
          return this.widthMax * (320 + 8) / 375 + 'px'
        }
        return this.widthMax / 4 + 'px'
      },
      getImageHeight() {
        if (this.widthMax <= 768) {
          return 'calc(384/375*100vw)'
        }
        return (this.widthMax / 4 - (32+48+3*2) * (this.widthMax / 1920)) / 360 * 480 + 'px'
      },
      getSpUrl(item) {
        if (item.viewerType !== 'canvas-panel' && item.viewerType !== 'mirador') {
          return item.viewerUrl;
        } else {
          if (item.viewerType === 'canvas-panel') {
            if (item.viewerUrl) {
              return this.$router.resolve({name: 'ViewerCanvasPanel', query: {iiif: item.viewerUrl, title: this.artwork.title}}).href
            } else {
              return this.$router.resolve({name: 'ViewerMirador', query: { iiif: this.miradorURL }}).href
            }
          }
          if (item.viewerType === 'mirador') {
            return this.$router.resolve({name: 'ViewerMirador', query: { iiif: item.viewerUrl }}).href
          }
        }
      }
  }
}
